
/** --------------------------------------------------------------------------------------------------
 * 開啟'儲存中'視窗
 * -------------------------------------------------------------------------------------------------- */
window.showLoadingDialog = function () {
    $("#rd-loading").show();
}

window.hideLoadingDialog = function (){
    $("#rd-loading").hide();
}
